import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, Subject } from 'rxjs';
import { map, catchError, tap } from 'rxjs/operators';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RestService {
  baseUrl: string;
  token: string;
  private userLoggedIn = new Subject<boolean>();
  project = new Subject<string>();
  rating = new Subject<string>();
  riskStatus = new Subject<string>();
  register = new Subject<string>();
  bubbleProject = new Subject<string>();
  pyramidProject = new Subject<string>();
  movementProject = new Subject<string>();
  bubbleRegister = new Subject<string>();
  pyramidRegister = new Subject<string>();
  movementRegister = new Subject<string>();
  pieRegister = new Subject<string>();
  movementRating = new Subject<string>();
  pieRating = new Subject<string>();
  bubbleRating = new Subject<string>();
  bridgeProject = new Subject<string>();
  pieProject = new Subject<string>();
  categoryLoading = new Subject<string>();
  getRoleAccess: any;
  constructor(private http: HttpClient) {
    this.baseUrl = environment.API;
    this.userLoggedIn.next(false);
  }

  setUserLoggedIn(userLoggedIn: boolean) {
    this.userLoggedIn.next(userLoggedIn);
  }

  getUserLoggedIn(): Observable<boolean> {
    return this.userLoggedIn.asObservable();

  }
  getToken() {
    return sessionStorage.getItem('token');
  }
  private extractData(res: Response) {
    const body = res;
    return body || {};
  }
  model(id): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };
    return this.http.get(this.baseUrl + id, httpOptions,
    ).pipe(map(this.extractData));
  }

  reportModel(id, options: any): Observable<any> {
    return this.http.get(this.baseUrl + id, options).pipe(map(result => {
      return result;
    }
    ));
  }

  getReport(url) {
    const downloadUrl = [url, 'access_token=' + sessionStorage.getItem('token')].join('?');
    window.open(downloadUrl, '_blank');
  }

  postModel(model, id): Observable<any> {
    return this.http.post<any>(this.baseUrl + id, JSON.stringify(model), {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    }).pipe(
      tap(_ => ''),
      catchError(this.handleError<any>('postModel')),
    );
  }

  postModelWithFile(model, id): Observable<any> {

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Transfer-Encoding': 'utf-8',

      }),
    };
    return this.http.post<any>(this.baseUrl + id, model)
      .pipe(
        tap(_ => ''),
        catchError(this.handleError<any>('postModelWithFile')),
      );
  }

  updateModel(model, id): Observable<any> {
    return this.http.put(this.baseUrl + id, JSON.stringify(model),
      {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
        }),
      }).pipe(
        tap(_ => ''),
        catchError(this.handleError<any>('updateModel')),
      );
  }

  deleteModel(id): Observable<any> {
    return this.http.post<any>(this.baseUrl + id, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    }).pipe(
      tap(_ => ''),
      catchError(this.handleError<any>('deleteModel')),
    );
  }


  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead
      // TODO: better job of transforming error for user consumption
      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }
}

